import type {CommonProps} from './types';

const InlinePlusSmall = ({
  color = 'currentColor',
  size = 10,
  ...rest
}: CommonProps) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M2 6h8M6 2v8"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default InlinePlusSmall;
